import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchDocumentReport(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_REPORT_FETCH,
    (organisationId, projectId, documentId) => {
      const reqString = `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/report`;
      return requestor
        .get(reqString, {withCredentials: true})
        .then(response => ({
          organisation_id: parseInt(organisationId, 10),
          project_id: parseInt(projectId, 10),
          document_id: parseInt(documentId, 10),
          ...response.data,
        }));
    },
  );
}
